<template>
    <input :type="type" pattern="[A-Za-z0-9]*" :placeholder="hint" :value="value" class="form-control input-lg"
        autocomplete="off" data-lpignore="true" @input="updateValue($event.target.value)" />
</template>

<script>
export default {
    props: {
        hint: {
            type: String,
            required: true,
        },
        uppercase: {
            type: Boolean,
            required: true,
            default: true,
        },
        value: String,
        type: {
            type: String,
            required: false,
            default: "text"
        }
    },
    methods: {
        updateValue(newValue) {
            this.$emit('input', this.uppercase ? newValue.toUpperCase() : newValue);
        }
    }
}
</script>

<style scoped>
input {
    width: 21.5rem;
    height: 5.8125rem;
    color: var(--color-primary);
    font-size: 2rem;
    text-align: center;
    font-family: Roboto, sans-serif;
    text-transform: v-bind('uppercase ? "uppercase" : "none"');
    background: white;
    border: 0.1875rem solid var(--color-primary);
    border-radius: var(--button-border-radius);
    box-shadow: var(--shadow);
    margin-bottom: 0.5rem;
}
input.form-control:focus {
    border: 0.1875rem solid var(--color-primary-light);
}

</style>